import { createVNode, render, getCurrentInstance, type Component } from 'vue';

interface OpenDialogOptions {
  props?: Record<string, any>;
  modelProp?: string;
  /**
   * 弹窗关闭时的回调
   */
  onClose?: () => void;
}

/**
 * 函数式打开任意 dialog 组件，支持自定义 v-model 名称
 */
export function openDialog(component: Component, options: OpenDialogOptions = {}) {
  const { props = {}, modelProp = 'modelValue', onClose } = options;

  const container = document.createElement('div');

  document.body.appendChild(container);

  // 尝试继承当前组件的 appContext（这样弹窗可以使用 i18n / store / element-plus 等）
  const instance = getCurrentInstance();
  const appContext = instance?.appContext;

  // 关闭与清理逻辑
  const destroy = () => {
    try {
      render(null, container);
      container.remove();
    } catch (e) {
      console.error(e);
    }
    onClose?.();
  };

  const propKey = modelProp;
  const updateEventForProp = `onUpdate:${modelProp}`; // e.g. onUpdate:isShowPwdDialog
  const updateEventDefault = 'onUpdate:modelValue';

  const vnode = createVNode(component, {
    ...props,
    [propKey]: true,
    [updateEventForProp]: (val: boolean) => {
      if (!val) destroy();
    },
    [updateEventDefault]: (val: boolean) => {
      if (!val) destroy();
    }
  } as any);

  if (appContext) {
    vnode.appContext = appContext;
  }

  render(vnode, container);

  // 方便外部手动关闭
  return {
    close() {
      destroy();
    }
  };
}